<template>
  <div v-if="totalPages > 0" class="ew-pagination">
    <div class="ew-pagination-info">
      Página <strong>{{ page }}</strong> de <strong>{{ totalPages }}</strong>
      <span v-if="totalItems !== null"> · {{ totalItems }} registros</span>
    </div>
    <div class="ew-pagination-controls">
      <label v-if="perPageOptions.length" class="ew-pagination-perpage">
        <span>Por página</span>
        <select class="custom-select custom-select-sm" :value="perPage" @change="$emit('per-page', Number($event.target.value))">
          <option v-for="n in perPageOptions" :key="n" :value="n">{{ n }}</option>
        </select>
      </label>
      <button type="button" class="btn btn-sm btn-outline-secondary ew-pagination-btn" :disabled="page <= 1"
        aria-label="Página anterior" @click="$emit('change', page - 1)">
        <i class="bi bi-chevron-left"></i>
      </button>
      <button type="button" class="btn btn-sm btn-outline-secondary ew-pagination-btn" :disabled="page >= totalPages"
        aria-label="Página siguiente" @click="$emit('change', page + 1)">
        <i class="bi bi-chevron-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TablePagination',
  props: {
    page: { type: Number, required: true },
    totalPages: { type: Number, required: true },
    perPage: { type: Number, default: 20 },
    perPageOptions: { type: Array, default: () => [] },
    totalItems: { type: Number, default: null }
  }
}
</script>

<style scoped>
.ew-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 4px 4px;
  color: #6b7185;
  font-size: 0.85rem;
}

.ew-pagination strong {
  color: #1c2030;
  font-weight: 600;
}

.ew-pagination-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ew-pagination-perpage {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 8px 0 0;
  color: #6b7185;
  font-weight: 400;
}

.ew-pagination-perpage select {
  width: auto;
}

.ew-pagination-btn {
  width: 34px;
  height: 32px;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/TablePagination.vue